import React, { useEffect, useState } from "react";
import axios from "axios";
import "../assets/css/promote.css";

const isProduction = process.env.NODE_ENV === "production";
const API_BASE_URL = isProduction
  ? process.env.REACT_APP_API_BASE_URL
  : "http://localhost:3003";

const PromoteStudents = () => {
  const [programmes, setProgrammes] = useState([]);
  const [levels, setLevels] = useState([]);
  const [selectedProgramme, setSelectedProgramme] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    async function fetchFilters() {
      try {
        const [progRes, lvlRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/api/programmes`),
          axios.get(`${API_BASE_URL}/api/levels`),
        ]);
        setProgrammes(progRes.data);
        setLevels(lvlRes.data);
      } catch (err) {
        console.error("Filter load error:", err);
      }
    }
    fetchFilters();
  }, []);

  const handlePromote = async () => {
    setMessage("");
    setError("");
    try {
      await axios.post(
        `${API_BASE_URL}/api/promote-students`,
        { department: selectedProgramme, level: selectedLevel },
        { headers: { "Content-Type": "application/json" } }
      );
      setMessage("Students promoted successfully");
    } catch (err) {
      console.error("Promotion error:", err);
      setError("Failed to promote students");
    }
  };

  return (
    <div className="promote-container">
      <h2>Promote Students</h2>
      {error && <div className="error-toast">{error}</div>}
      {message && <div className="success-toast">{message}</div>}

      <div className="filter-row">
        <div className="filter-item">
          <label>Programme</label>
          <select
            value={selectedProgramme}
            onChange={(e) => setSelectedProgramme(e.target.value)}
          >
            <option value="">All Programmes</option>
            {programmes.map((p) => (
              <option key={p.ProgrammeID} value={p.Programme}>
                {p.Programme}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-item">
          <label>Current Level</label>
          <select
            value={selectedLevel}
            onChange={(e) => setSelectedLevel(e.target.value)}
          >
            <option value="">All Levels</option>
            {levels.map((lv) => (
              <option key={lv} value={lv}>
                {lv}
              </option>
            ))}
          </select>
        </div>

        <button onClick={handlePromote} className="promote-button">
          Promote
        </button>
      </div>
    </div>
  );
};

export default PromoteStudents;
